// extracted by mini-css-extract-plugin
export default {"VideoCardSizes":"VideoCard_VideoCardSizes__PiKe8","Frame":"VideoCard_Frame__HSUpv"};